import React, { useState, useEffect } from 'react';
import { scrollToTop } from '../utils';
import { fetchGarantia, Registrar } from '../services/products-api';
import { useLanguage } from '../LanguageContext';

const GarantiaGloomisForm = () => {
    const { language } = useLanguage();
    const [formData, setFormData] = useState({
        nome: '',
        endereco: '',
        email: '',
        codigoProduto: '',
        partNumber: '',
        modelo: '',
        serie: '',
        familia: '',
        numeroSerie: '',
        lojaCompra: '',
        dataCompra: '',
        numeroFatura: ''
    });

    const [produtos, setProdutos] = useState([]);
    const [protocolo, setProtocolo] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});

    // Dicionário de traduções
    const translations = {
        'en-US': {
            title: 'G. Loomis Warranty Registration',
            personalInfo: 'Personal Information',
            fullName: 'Full Name *',
            fullAddress: 'Full Address *',
            email: 'Email *',
            productInfo: 'Product Information',
            productCode: 'Product Code *',
            selectProduct: 'Select a product',
            partNumber: 'Part Number',
            model: 'Model *',
            serie: 'Series',
            family: 'Family',
            serialNumber: 'Serial Number *',
            serialPlaceholder: 'Ex: AB12345',
            purchaseInfo: 'Purchase Information',
            storeName: 'Store where you purchased *',
            purchaseDate: 'Purchase Date *',
            invoiceNumber: 'Invoice Number *',
            registerButton: 'Register Product',
            processing: 'Processing...',
            successTitle: 'Registration Completed Successfully!',
            protocolNumber: 'Protocol Number:',
            saveProtocol: 'Save this number for future reference. You will receive a confirmation email shortly.',
            registerAnother: 'Register Another Product',
            // Error messages
            nameRequired: 'Name is required',
            addressRequired: 'Address is required',
            emailRequired: 'Email is required',
            emailInvalid: 'Invalid email',
            productRequired: 'Please select a product',
            modelRequired: 'Model is required',
            serialRequired: 'Serial number is required',
            storeRequired: 'Store name is required',
            purchaseDateRequired: 'Purchase date is required',
            invoiceRequired: 'Invoice number is required',
            futureDate: 'Purchase date cannot be in the future',
            loadError: 'Error loading products. Please try again.',
            submitError: 'Error processing registration. Please try again.'
        },
        'es-MX': {
            title: 'Registro de Garantía G. Loomis',
            personalInfo: 'Información Personal',
            fullName: 'Nombre Completo *',
            fullAddress: 'Dirección Completa *',
            email: 'Correo Electrónico *',
            productInfo: 'Información del Producto',
            productCode: 'Código del Producto *',
            selectProduct: 'Seleccione un producto',
            partNumber: 'Part Number',
            model: 'Modelo *',
            serie: 'Serie',
            family: 'Familia',
            serialNumber: 'Número de Serie *',
            serialPlaceholder: 'Ej: AB12345',
            purchaseInfo: 'Información de Compra',
            storeName: 'Tienda donde Compró *',
            purchaseDate: 'Fecha de Compra *',
            invoiceNumber: 'Número de Factura *',
            registerButton: 'Registrar Producto',
            processing: 'Procesando...',
            successTitle: '¡Registro Completado con Éxito!',
            protocolNumber: 'Número de Protocolo:',
            saveProtocol: 'Guarde este número para futuras referencias. Recibirá un correo de confirmación en breve.',
            registerAnother: 'Registrar Otro Producto',
            // Error messages
            nameRequired: 'Nombre es obligatorio',
            addressRequired: 'Dirección es obligatoria',
            emailRequired: 'Correo electrónico es obligatorio',
            emailInvalid: 'Correo electrónico inválido',
            productRequired: 'Seleccione un producto',
            modelRequired: 'Modelo es obligatorio',
            serialRequired: 'Número de serie es obligatorio',
            storeRequired: 'Tienda donde compró es obligatoria',
            purchaseDateRequired: 'Fecha de compra es obligatoria',
            invoiceRequired: 'Número de factura es obligatorio',
            futureDate: 'La fecha de compra no puede ser futura',
            loadError: 'Error al cargar productos. Intente nuevamente.',
            submitError: 'Error al procesar el registro. Por favor, intente nuevamente.'
        }
    };

    // Obter texto traduzido
    const t = (key) => {
        const currentLang = language === 'es-MX' ? 'es-MX' : 'en-US';
        return translations[currentLang][key] || translations['en-US'][key] || key;
    };

    useEffect(() => {
        scrollToTop();
        const pageTitle = language === 'es-MX'
            ? "Registro de Producto G. Loomis | Shimano Mexico"
            : "G. Loomis Product Registration | Shimano";
        document.title = pageTitle;

        fetchProdutos();
    }, [language]);

    const fetchProdutos = async () => {
        try {
            setLoading(true);

            const response = await fetchGarantia();

            console.log(response?.data?.Data?.Dados)
            const dados = response?.data?.Data?.Dados || [];
            const produtosFormatados = dados
                .filter(produto => produto.GLoomis === 'N')
                .map(produto => ({
                    id: produto.idProduto,
                    codigo: produto.CodigoProduto,
                    partNumber: produto.EAN,
                    modelo: produto.Descricao?.trim() || '',
                    serie: produto.Serie || '',
                    familia: produto.Familia || ''
                }))
                .sort((a, b) => a.modelo.localeCompare(b.modelo));

            setProdutos(produtosFormatados);
            console.log(produtosFormatados)
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
            setErrors(prev => ({
                ...prev,
                submit: t('loadError')
            }));
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleProdutoSelect = (e) => {
        const codigoSelecionado = e.target.value;
        const produtoSelecionado = produtos.find(p => p.codigo === codigoSelecionado);
        console.log(codigoSelecionado, produtoSelecionado)
        if (produtoSelecionado) {
            setFormData(prev => ({
                ...prev,
                codigoProduto: codigoSelecionado,
                partNumber: produtoSelecionado.partNumber,
                // NÃO preenche automaticamente o modelo (mantém o valor atual ou limpa)
                serie: produtoSelecionado.serie,
                familia: produtoSelecionado.familia
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                codigoProduto: '',
                partNumber: '',
                serie: '',
                familia: ''
            }));
        }

        if (errors.codigoProduto) {
            setErrors(prev => ({
                ...prev,
                codigoProduto: ''
            }));
        }
        
        if (errors.modelo) {
            setErrors(prev => ({
                ...prev,
                modelo: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.nome.trim()) newErrors.nome = t('nameRequired');
        if (!formData.endereco.trim()) newErrors.endereco = t('addressRequired');
        if (!formData.email.trim()) {
            newErrors.email = t('emailRequired');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = t('emailInvalid');
        }
        if (!formData.codigoProduto) newErrors.codigoProduto = t('productRequired');
        if (!formData.modelo.trim()) newErrors.modelo = t('modelRequired');
        if (!formData.numeroSerie.trim()) newErrors.numeroSerie = t('serialRequired');
        if (!formData.lojaCompra.trim()) newErrors.lojaCompra = t('storeRequired');
        if (!formData.dataCompra) newErrors.dataCompra = t('purchaseDateRequired');
        if (!formData.numeroFatura.trim()) newErrors.numeroFatura = t('invoiceRequired');

        if (formData.dataCompra) {
            const dataCompra = new Date(formData.dataCompra);
            const hoje = new Date();
            if (dataCompra > hoje) {
                newErrors.dataCompra = t('futureDate');
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        setLoading(true);

        try {
            const response = await Registrar({
                nome: formData.nome,
                endereco: formData.endereco,
                email: formData.email,
                idProduto: produtos.find(p => p.codigo === formData.codigoProduto)?.id,
                numeroFatura: formData.numeroFatura,
                numeroSerie: formData.numeroSerie,
                modelo: formData.modelo,
                lojaCompra: formData.lojaCompra,
                dataCompra: formData.dataCompra
                
            });

            const novoProtocolo =
                response?.data?.Data?.NumeroProtocolo || '';

            setProtocolo(`GL-${novoProtocolo}`);
            setSubmitted(true);

        } catch (error) {
            console.error('Erro ao enviar formulário:', error);
            setErrors({
                submit: t('submitError')
            });
        } finally {
            setLoading(false);
        }
    }; 

    const handleReset = () => {
        setFormData({
            nome: '',
            endereco: '',
            email: '',
            codigoProduto: '',
            partNumber: '',
            modelo: '',
            serie: '',
            familia: '',
            numeroSerie: '',
            lojaCompra: '',
            dataCompra: '',
            numeroFatura: ''
        });
        setSubmitted(false);
        setProtocolo('');
        setErrors({});
    };

    if (submitted) {
        return (
            <section className="registro-sucesso container" style={{ maxWidth: '600px', margin: '40px auto', padding: '0 20px' }}>
                <div style={{
                    backgroundColor: '#d4edda',
                    border: '1px solid #c3e6cb',
                    borderRadius: '8px',
                    padding: '30px',
                    textAlign: 'center'
                }}>
                    <h2 style={{ color: '#155724', marginBottom: '20px', fontSize: '20px' }}>
                        {t('successTitle')}
                    </h2>

                    <div style={{
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        padding: '20px',
                        marginBottom: '20px'
                    }}>
                        <p style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                            {t('protocolNumber')}
                        </p>
                        <p style={{
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#0054A6',
                            fontFamily: 'monospace',
                            letterSpacing: '2px'
                        }}>
                            {protocolo}
                        </p>
                    </div>

                    <p style={{ fontSize: '12px', color: '#666', marginBottom: '20px' }}>
                        {t('saveProtocol')}
                    </p>

                    <button
                        onClick={handleReset}
                        style={{
                            backgroundColor: '#0054A6',
                            color: '#fff',
                            border: 'none',
                            padding: '12px 30px',
                            borderRadius: '5px',
                            fontSize: '14px',
                            cursor: 'pointer',
                            fontWeight: 'bold'
                        }}
                    >
                        {t('registerAnother')}
                    </button>
                </div>
            </section>
        );
    }

    return (
        <section className="registro-garantia container" style={{ maxWidth: '800px', margin: '40px auto', padding: '0 20px' }}>
            <div className="sect-header">
                <div className="sect-titulo">
                    <h1 style={{ textAlign: 'center', marginBottom: '30px', fontSize: '24px' }}>
                        {t('title')}
                    </h1>
                </div>
            </div>

            {errors.submit && (
                <div style={{
                    backgroundColor: '#f8d7da',
                    border: '1px solid #f5c6cb',
                    borderRadius: '5px',
                    padding: '15px',
                    marginBottom: '20px',
                    color: '#721c24',
                    fontSize: '12px'
                }}>
                    {errors.submit}
                </div>
            )}

            <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: '30px' }}>
                    <h4 style={{
                        marginBottom: '20px',
                        fontSize: '16px',
                        borderBottom: '1px solid #eee',
                        paddingBottom: '10px'
                    }}>
                        {t('personalInfo')}
                    </h4>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                            {t('fullName')}
                        </label>
                        <input
                            type="text"
                            name="nome"
                            value={formData.nome}
                            onChange={handleInputChange}
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '12px',
                                border: errors.nome ? '1px solid #dc3545' : '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                        {errors.nome && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.nome}</span>}
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                            {t('fullAddress')}
                        </label>
                        <input
                            type="text"
                            name="endereco"
                            value={formData.endereco}
                            onChange={handleInputChange}
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '12px',
                                border: errors.endereco ? '1px solid #dc3545' : '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                        {errors.endereco && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.endereco}</span>}
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                            {t('email')}
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '12px',
                                border: errors.email ? '1px solid #dc3545' : '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                        {errors.email && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.email}</span>}
                    </div>
                </div>

                <div style={{ marginBottom: '30px' }}>
                    <h4 style={{
                        marginBottom: '20px',
                        fontSize: '16px',
                        borderBottom: '1px solid #eee',
                        paddingBottom: '10px'
                    }}>
                        {t('productInfo')}
                    </h4>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                            {t('productCode')}
                        </label>
                        <select
                            name="codigoProduto"
                            value={formData.codigoProduto}
                            onChange={handleProdutoSelect}
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '12px',
                                border: errors.codigoProduto ? '1px solid #dc3545' : '1px solid #ddd',
                                borderRadius: '4px',
                                backgroundColor: '#fff'
                            }}
                        >
                            <option value="">{t('selectProduct')}</option>
                            {produtos.map(produto => (
                                <option key={produto.id} value={produto.codigo}>
                                    {produto.codigo} - {produto.modelo}
                                </option>
                            ))}
                        </select>
                        {errors.codigoProduto && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.codigoProduto}</span>}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                                {t('partNumber')}
                            </label>
                            <input
                                type="text"
                                name="partNumber"
                                value={formData.partNumber}
                                readOnly
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    fontSize: '12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: '#f5f5f5',
                                    cursor: 'not-allowed'
                                }}
                            />
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                                {t('model')}
                            </label>
                            <input
                                type="text"
                                name="modelo"
                                value={formData.modelo}
                                onChange={handleInputChange}
                                placeholder={t('model')}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    fontSize: '12px',
                                    border: errors.modelo ? '1px solid #dc3545' : '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: '#fff'
                                }}
                            />
                            {errors.modelo && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.modelo}</span>}
                        </div>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                                {t('serie')}
                            </label>
                            <input
                                type="text"
                                name="serie"
                                value={formData.serie}
                                readOnly
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    fontSize: '12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: '#f5f5f5',
                                    cursor: 'not-allowed'
                                }}
                            />
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                                {t('family')}
                            </label>
                            <input
                                type="text"
                                name="familia"
                                value={formData.familia}
                                readOnly
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    fontSize: '12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    backgroundColor: '#f5f5f5',
                                    cursor: 'not-allowed'
                                }}
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                            {t('serialNumber')}
                        </label>
                        <input
                            type="text"
                            name="numeroSerie"
                            value={formData.numeroSerie}
                            onChange={handleInputChange}
                            placeholder={t('serialPlaceholder')}
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '12px',
                                border: errors.numeroSerie ? '1px solid #dc3545' : '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                        {errors.numeroSerie && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.numeroSerie}</span>}
                    </div>
                </div>

                <div style={{ marginBottom: '30px' }}>
                    <h4 style={{
                        marginBottom: '20px',
                        fontSize: '16px',
                        borderBottom: '1px solid #eee',
                        paddingBottom: '10px'
                    }}>
                        {t('purchaseInfo')}
                    </h4>

                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                            {t('storeName')}
                        </label>
                        <input
                            type="text"
                            name="lojaCompra"
                            value={formData.lojaCompra}
                            onChange={handleInputChange}
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '12px',
                                border: errors.lojaCompra ? '1px solid #dc3545' : '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                        {errors.lojaCompra && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.lojaCompra}</span>}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                        <div>
                            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                                {t('purchaseDate')}
                            </label>
                            <input
                                type="date"
                                name="dataCompra"
                                value={formData.dataCompra}
                                onChange={handleInputChange}
                                max={new Date().toISOString().split('T')[0]}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    fontSize: '12px',
                                    border: errors.dataCompra ? '1px solid #dc3545' : '1px solid #ddd',
                                    borderRadius: '4px'
                                }}
                            />
                            {errors.dataCompra && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.dataCompra}</span>}
                        </div>

                        <div>
                            <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px', fontWeight: 'bold' }}>
                                {t('invoiceNumber')}
                            </label>
                            <input
                                type="text"
                                name="numeroFatura"
                                value={formData.numeroFatura}
                                onChange={handleInputChange}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    fontSize: '12px',
                                    border: errors.numeroFatura ? '1px solid #dc3545' : '1px solid #ddd',
                                    borderRadius: '4px'
                                }}
                            />
                            {errors.numeroFatura && <span style={{ color: '#dc3545', fontSize: '11px' }}>{errors.numeroFatura}</span>}
                        </div>
                    </div>
                </div>

                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            backgroundColor: loading ? '#ccc' : '#0054A6',
                            color: '#fff',
                            border: 'none',
                            padding: '12px 40px',
                            borderRadius: '5px',
                            fontSize: '14px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontWeight: 'bold'
                        }}
                    >
                        {loading ? t('processing') : t('registerButton')}
                    </button>
                </div>
            </form>
        </section>
    );
};

export default GarantiaGloomisForm;